import { Link, LinkProps } from 'react-router-dom';
import { styled } from '@mui/material';

interface StyledLinkProps extends LinkProps {
  $underline?: boolean;
  $color?: string;
  $fontWeight?: string;
  $fontSize?: string;
}

export const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => !['$underline', '$color', '$fontWeight', '$fontSize'].includes(prop as string),
})<StyledLinkProps>(({ $underline, $color, $fontWeight, $fontSize }) => ({
  textDecoration: $underline ? 'underline' : 'none',
  color: $color,
  fontWeight: $fontWeight,
  fontSize: $fontSize,
}));
